// extracted by mini-css-extract-plugin
module.exports = {"data-center-wrap":"DataCenter_index_data-center-wrap__33iP_"};